<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <drivers-period-available-edit-form
        @on-submit="onDriverPeriodAvailableEditSubmit"
      ></drivers-period-available-edit-form>
    </div>
  </div>
</template>
<script>
import DriversPeriodAvailableEditForm from "./DriversPeriodAvailableEditForm.vue";

export default {
  components: {
    DriversPeriodAvailableEditForm
  },
  data() {
    return {
      driverPeriodAvailableEditModal: {}
    };
  },
  methods: {
    onDriverPeriodAvailableEditSubmit(model) {
      this.driverPeriodAvailableEditModal = model;
      // this.$http.post(
      //   this.$apiBaseUrl + 'routes/' + this.routeEditModel.id, Object.assign(this.routeEditModel)
      // ).then(response => {
      // }, response => {
      // });
    }
  }
};
</script>
<style></style>
